import { render, staticRenderFns } from "./DocumentsTable.vue?vue&type=template&id=0f5d4666&scoped=true&lang=pug&"
import script from "./DocumentsTable.vue?vue&type=script&lang=ts&"
export * from "./DocumentsTable.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentsTable.vue?vue&type=style&index=0&id=0f5d4666&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5d4666",
  null
  
)

export default component.exports